/*
 * sorting-headers-enum.ts
 * dev-utms-shop-admin
 * 
 * Last Modified: 15.07.2024
 * Modified By: Tetiana Makovii
 * 
 * Created by Tetiana Makovii on 04.07.2023
 * Copyright © 2026 Sonova AG. All rights reserved.
 */

export enum SortingHeadersEnum
{
    patientId = "patientId",
    name = "name",
    email = "email",
    shopId="shopId",
    lastSeen="lastSeen",
    dateOfRegistration="dateOfRegistration"
}
